import * as factory from 'tods-competition-factory';

import { db } from 'services/storage/db';
import TournamentServiceImpl from 'services/tournament/tournamentServiceImpl';
import { isStandalone } from 'utils/environment';

import { TOURNAMENT_ENGINE } from './graphql/constants';

const methods = [];

function functionOrLog(s, results) {
  return typeof window.dev[s] === 'function'
    ? window.dev[s](results)
    : // eslint-disable-next-line no-console
      (window.dev.allSubscriptions || window.dev[s]) && console.log(s, results);
}

const subscriptions = {
  addDrawDefinition: (results) => functionOrLog('addDrawDefinition', results),
  deletedDrawIds: (results) => functionOrLog('deletedDrawIds', results),
  addVenue: (results) => functionOrLog('addVenue', results),
  deleteVenue: (results) => functionOrLog('deleteVenue', results),
  modifyMatchUp: (results) => functionOrLog('modifyMatchUp', results),
  addMatchUps: (results) => functionOrLog('addMatchUps', results),
  deletedMatchUpIds: (results) => functionOrLog('deletedMatchUpIds', results),
  publishEvent: (results) => functionOrLog('publishEvent', results),
  unPublishEvent: (results) => functionOrLog('unPublishEvent', results),
  publishEventSeeding: (results) => functionOrLog('publishEventSeeding', results),
  unPublishEventSeeding: (results) => functionOrLog('unPublishEventSeeding', results),
  modifyDrawEntries: (results) => functionOrLog('modifyDrawEntries', results),
  modifyEventEntries: (results) => functionOrLog('modifyEventEntries', results),
  modifyDrawDefinition: (results) => functionOrLog('modifyDrawDefinition', results),
  modifyParticipants: (results) => functionOrLog('modifyParticipants', results),
  modifyVenue: (results) => functionOrLog('modifyVenue', results),
  modifySeedAssignments: (results) => functionOrLog('modifySeedAssignments', results),
  modifyPositionAssignments: (results) => functionOrLog('modifyPositionAssignments', results),
};

export function setDev({ admin } = {}) {
  if (
    admin ||
    isStandalone() ||
    ['tmx.clubspark', 'tmx-dev', 'clubspark.dev', 'f04-', 'tst-', 'stg-', 'desk.clubspark.io', 'itat-desk'].some(
      (frag) => window.location.host.startsWith(frag),
    )
  ) {
    // eslint-disable-next-line no-console
    console.log('%cdev initialized', 'color: yellow');
    window.dev = {};

    factory.globalState.setSubscriptions({ subscriptions });
  }

  // convenience for localHost/demo mode side loading tournamentRecords
  // useful for debugging tournamentRecords pulled from production/f04/stage
  const load = (json) => {
    if (typeof json === 'object') {
      const t = json.tournamentRecord || json;
      const tournamentId = t?.tournamentId;
      if (tournamentId) {
        db.addTournament(t).then(() => {
          window.location = `/tournament/${tournamentId}`;
        });
      }
    }
  };

  const getTournament = () => factory.tournamentEngine.getTournament().tournamentRecord;
  const tournamentService = new TournamentServiceImpl();
  const modifyTournament = (methods) => {
    tournamentService.saveTournament(getTournament().tournamentId, TOURNAMENT_ENGINE, methods);
    // eslint-disable-next-line no-console
    console.log('%cModified! Refresh or modify history to view changes...', 'color: lightgreen');
  };

  const sup = (context) => {
    factory.globalState.setDevContext({ admin: 'super', ...context });
    // eslint-disable-next-line no-console
    console.log('%cSuper Admin!', 'color: cyan');
  };

  addDev({
    competitionEngine: factory.competitionEngine,
    tournamentEngine: factory.tournamentEngine,

    getContext: factory.globalState.getDevContext,
    context: factory.globalState.setDevContext,
    addMethod: (method) => methods.push(method),
    subscriptions: Object.keys(subscriptions),
    generateMockTournament,
    modifyTournament,
    getTournament,
    getMethods,
    factory,
    load,
    sup,
  });
}

export function addDev(variable) {
  try {
    Object.keys(variable).forEach((key) => (window.dev[key] = variable[key]));
    //eslint-disable-next-line unused-imports/no-unused-vars
  } catch (err) {
    // eslint-disable-next-line
    console.log('production environment');
  }
}

export function getMethods(destroy) {
  if (destroy) {
    return methods.splice(0, methods.length);
  } else return methods;
}

function generateMockTournament(params) {
  const { tournamentRecord, error } = factory.mocksEngine.generateTournamentRecord(params);
  if (error) {
    // eslint-disable-next-line no-console
    console.log({ error });
  } else {
    const tournamentId = tournamentRecord.tournamentId;
    db.addTournament(tournamentRecord).then(() => {
      window.location = `/tournament/${tournamentId}`;
    });
  }
}
